module.exports = __webpack_public_path__ + "static/SVHome-01-528e8132270f377d46b063af01806ad1.png";